function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M0.95414 7.99997C0.95414 8.47335 1.3379 8.85711 1.81128 8.85711C2.28467 8.85711 2.66843 8.47335 2.66843 7.99997C2.66843 7.52658 2.28467 7.14282 1.81128 7.14282C1.3379 7.14282 0.95414 7.52658 0.95414 7.99997Z",
  stroke: "url(#paint0_linear_5475:2073)",
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M0.95414 14C0.95414 14.4734 1.3379 14.8571 1.81128 14.8571C2.28467 14.8571 2.66843 14.4734 2.66843 14C2.66843 13.5266 2.28467 13.1428 1.81128 13.1428C1.3379 13.1428 0.95414 13.5266 0.95414 14Z",
  stroke: "url(#paint1_linear_5475:2073)",
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M0.95414 1.99997C0.95414 2.47335 1.3379 2.85711 1.81128 2.85711C2.28467 2.85711 2.66843 2.47335 2.66843 1.99997C2.66843 1.52658 2.28467 1.14282 1.81128 1.14282C1.3379 1.14282 0.95414 1.52658 0.95414 1.99997Z",
  stroke: "url(#paint2_linear_5475:2073)",
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref5 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint0_linear_5475:2073",
  x1: 1.81128,
  y1: 1.14282,
  x2: 1.81128,
  y2: 14.8571,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#161626"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint1_linear_5475:2073",
  x1: 1.81128,
  y1: 1.14282,
  x2: 1.81128,
  y2: 14.8571,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#161626"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint2_linear_5475:2073",
  x1: 1.81128,
  y1: 1.14282,
  x2: 1.81128,
  y2: 14.8571,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#161626"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1
})));

function SvgEllipses(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 4,
    height: 16,
    viewBox: "0 0 4 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEllipses);
export default __webpack_public_path__ + "static/media/ellipses.76097520.svg";
export { ForwardRef as ReactComponent };